import React from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { paypalSubscription, stripeDecode, updatePayment } from "./service";
import Translate from "../../../Components/Multilanguage/Translate";

const PaymentSuccess = () => {
  const projectInfo = useSelector((state) => state?.projectInfo?.value);
  const accessToken = useSelector((state) => state?.accessToken?.value);
  const userDetails = useSelector((state) => state?.userDetails?.value);
  const appInfo = {
    projectDetails: projectInfo,
    accessToken: accessToken,
  };
  const navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  useEffect(() => {
    const sessionId = urlParams.get("session_id");
    const paypalData = urlParams.get("token")
      ? urlParams.get("token")
      : urlParams.get("amt");
    if (sessionId) {
      fetchStripeDecode(sessionId)
    } else if (paypalData) {
      let modeOfPayment = "paypal"
      updatePaymentApi(paypalData, modeOfPayment)
    }
  }, []);

  const paypalSusbscriptionApi = () => {
    const subID = localStorage.getItem("selectedSubId");

    let myInterval = setInterval(async () => {
      const response = await paypalSubscription(appInfo, subID);
      if (response?.status === 201) {
        clearInterval(myInterval);
        const isAndroid = localStorage.getItem("isAndroid");
        if (isAndroid == "true") {
          window.location.href = process.env.REACT_APP_WEB_VIEW_SUCCESS;// android succes redirect
        } else {
          // setIsLoading(false);
          // setIsSucces(true);
        }
      }
    }, 10 * 1000)
  }

  const updatePaymentApi = async (subscription, modeOfPayment ,isUpgrade) => {
    const updatePaymentResponse = await updatePayment(appInfo, subscription, modeOfPayment, "success" ,isUpgrade);
    if (updatePaymentResponse?.status === 200) {
      localStorage.removeItem("couponId");
      const isAndroid = localStorage.getItem("isAndroid");
      const iosSignup = localStorage.getItem("iosSignup");

      if (isAndroid == "true") {
        // window.location.href = window.location.origin + "/webviewsuccess";  // android success redirect
        window.location.href = appInfo?.projectDetails?.projectConfig.config?.ANDROID_PAYMENT_SUCCESS_URL;
      } else if (iosSignup == 'true') {
        localStorage.removeItem("iosSignup");
        setTimeout(() => {
          window.location.href = window.location.origin + "/ios-webview-success?key=" + appInfo?.accessToken;  // ios success redirect
        }, 2000);
      } else {
        // setIsLoading(false);
        // setIsSucces(true);
      }

    } else {
      const response = await updatePayment(appInfo, subscription, modeOfPayment, "failed")
      if (response?.status === 200) {
        const isAndroid = localStorage.getItem("isAndroid");
        if (isAndroid == "true") {
          // window.location.href = window.location.origin + "/webviewfailed";; // android error redirect
          window.location.href = appInfo?.projectDetails?.projectConfig.config?.ANDROID_PAYMENT_FAILED_URL;
        } else {
          navigate("/payment-failed")
        }
      }
    }
  }

  const fetchStripeDecode = async (sessionId) => {
    const stripeDecodeResponse = await stripeDecode(appInfo, sessionId)
    if (stripeDecodeResponse?.status === 200) {
      const subscription = stripeDecodeResponse?.data?.data?.subscription;
      let modeOfPayment = 'stripe';
      const isUpgrade = localStorage.getItem('isUpgrade') == 'true' ? true : false;
      updatePaymentApi(subscription, modeOfPayment, isUpgrade)
    }
  }

  const handleClick = () => {
    const showId = localStorage.getItem("showId");
    const eventId = localStorage.getItem("eventId");
    const vanityUrl = localStorage.getItem("vanityUrl")
    const isAndroid = localStorage.getItem("isAndroid")
    const iosSignup = localStorage.getItem("iosSignup")

    if (isAndroid == "true") {
      // window.location.href = window.location.origin + "/webviewsuccess";  // android success redirect
      window.location.href = appInfo?.projectDetails?.projectConfig.config?.ANDROID_PAYMENT_SUCCESS_URL;
    } else if (iosSignup == 'true') {
      localStorage.removeItem("iosSignup");
      setTimeout(() => {
        window.location.href = window.location.origin + "/ios-webview-success?key=" + appInfo?.accessToken;  // ios success redirect
      }, 2000);
    } else if (eventId) {
      navigate(`/live`, { state: { eventId: eventId } })
    } else if (vanityUrl) {
      navigate(`/movies/${vanityUrl}`, { state: { showId } })
    } else if (!showId && !eventId && !vanityUrl && !isAndroid && !iosSignup) {
      navigate("/")
    }
    setTimeout(() => {
      // Forces a full reload of the new page to call athe authentication API to reset the resubscribe flag
      if (userDetails?.user_subscription_id) {
        window.location.href = window.location.href;
      }
    }, 2000);
  }

  return (
    <div className={`success ${projectInfo?.projectConfig?.config?.BACKGROUND_COLOR ? 'bg' : ''}`}>
      <div className={`successContainer ${projectInfo?.projectConfig?.config?.BACKGROUND_COLOR ? 'bg' : ''}`}>
        <div className="checkIcon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="92"
            height="92"
            fill="#fff"
            className="bi bi-check2"
            viewBox="0 0 16 16"
          >
            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
          </svg>
        </div>
        <h5><Translate textKey={'success'} /></h5>
        <p><Translate textKey={'payment_success_message'} /></p>
        <button onClick={() => handleClick()}><Translate textKey={'ok'} /></button>
      </div>
    </div>
  );
};

export default PaymentSuccess;
